import { DefaultPalette } from 'office-ui-fabric-react';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { routes } from '../../common/routes';
import MessageCourier from '../../lib/MessageCourier';
import { defaultCommandBarButtonStyles, titleCommandBarButtonStyles } from '../../styles/button-styles';
import SystemClient from '../../system/SystemClient';
import ViewWrapperWithCommandBar from '../Common/Layout/ViewWrapperWithCommandBar';
import PlanillaDigitalView from './PlanillaDigitalView';
import { PlanillaPartido } from '../../system/PlanillaPartido/PlanillaPartido';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import PlanillaDigitalForm from './PlanillaDigitalForm';
import { useTranslation } from 'react-i18next';
import { IColor } from '@fluentui/react';
import AgregarJugadorDialog from './Dialogs/AgregarJugadorDialog';
import CambioCamisetaDialog from './Dialogs/CambioCamisetaDialog';
import FinalizarPartidoDialog from './Dialogs/FinalizarPartidoDialog';
import SeleccionarColorDialog from './Dialogs/SeleccionarColorDialog';
import PlanillaYaIniciadaErrorDialog from './Dialogs/PlanillaYaIniciadaErrorDialog';
import { MAX_HANDBALL_PLAYERS_PER_TEAM } from '../PlanillaPartidoOffline/ConfeccionPlanillaPartidoTeamOffline';
import Environment from '../../lib/Environment';
import { PlanillaPartidoArchivoSincronizacion } from './Sincronizacion/PlanillaPartidoArchivoSincronizacion';
import XhrRequestError from '../../lib/XhrRequestError';
import { Usuario } from '../../system/Usuario/Usuario';
import { EventoXPlanilla } from '../../system/EventoXPlanilla/EventoXPlanilla';
import { TimeoutXPlanilla } from '../../system/TimeoutXPlanilla/TimeoutXPlanilla';
// @ts-ignore^M
import useNavigatorOnline from 'use-navigator-online';
import DuracionTiemposReglamentariosDialog from './Dialogs/DuracionTiemposReglamentariosDialog';

export const SUSPENDIDO = 'S';
export const FINALIZADO = 'F';

interface IPlanillaPartidoViewController {
  system: SystemClient;
  courier: MessageCourier;
  environment: Environment;
  user?: Usuario;
  isPartidoOnline: boolean;
  planillaPartido?: PlanillaPartido;
  changeBlockUI: (state: boolean) => void;
}

const PlanillaPartidoViewController = ({
  system,
  courier,
  changeBlockUI,
  planillaPartido: pp,
  isPartidoOnline,
  ...props
}: IPlanillaPartidoViewController) => {
  const navigate = useNavigate();
  const [planillaDigitalForm, setPlanillaDigitalForm] = React.useState<PlanillaDigitalForm | undefined>(
    undefined
  );

  React.useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const [viewMode, setViewMode] = React.useState<string>('L');
  let { id } = useParams();
  const { t } = useTranslation();
  const forceUpdate = useForceUpdate();
  const [formIsValid, setFormIsValid] = React.useState(false);
  const [localColor, setLocalColor] = React.useState<string>('#000000');
  const [visitanteColor, setVisitanteColor] = React.useState<string>('#000000');
  const [showInitialDialog, setShowInitialDialog] = React.useState(true);
  const [invertedTeams, setInvertedTeams] = React.useState(false);
  const [countdownMode, setCountdownMode] = React.useState(true);
  const [matchIsOver, setMatchIsOver] = React.useState(false);
  const [onRefereeReview, setOnRefereeReview] = React.useState(false);
  const [showConfirmacionPlanillaDialog, setShowConfirmacionPlanillaDialog] = React.useState(false);
  const [showPlanillaYaIniciadaError, setShowPlanillaYaIniciadaError] = React.useState(false);

  const [showCambioCamiseta, setShowCambioCamiseta] = React.useState(false);
  const [showErrorConfirmacionArbitro, setShowErrorConfirmacionArbitro] = React.useState(false);
  const [showCambioCamisetaTeam, setShowCambioCamisetaTeam] = React.useState('');
  const [showAgregarJugador, setShowAgregarJugador] = React.useState(false);
  const [showAgregarJugadorTeam, setShowAgregarJugadorTeam] = React.useState('');
  const [equipoLocalCompleto, setEquipoLocalCompleto] = React.useState(false);
  const [equipoVisitanteCompleto, setEquipoVisitanteCompleto] = React.useState(false);
  const [configuracionPuedeAgregarJugador, setConfiguracionPuedeAgregarJugador] = React.useState(false);
  const [tipoFinalizacion, setTipoFinalizacion] = React.useState('');
  const [archivoSyncDescargado, setArchivoSyncDescargado] = React.useState(false);
  const [planillaPartido, setPlanillaPartido] = React.useState<PlanillaPartido>();
  const [showIndicaDuracionPeriodos, setShowIndicaDuracionPeriodos] = React.useState(false);

  const [useIndicaDuracionPeriodos, setUseIndicaDuracionPeriodos] = React.useState(false);
  const [startInExtra, setStartInExtra] = React.useState(false);
  const [tiempoPendienteJuegoEnSegundos, setTiempoPendienteJuegoEnSegundos] = React.useState<number>(0);

  const [shouldRetrySaveEvents, setShouldRetrySaveEvents] = React.useState(false);

  const [tiempoSuspendido, setTiempoSuspendido] = React.useState<string>('');
  const [shouldShowDescargarArchivoJSON, setShouldShowDescargarArchivoJSON] = React.useState(false);
  const [shouldShowPDF, setShouldShowPDF] = React.useState(false);

  const onBlurCustomInput = (customInput: CustomInputIfc) => {
    if (planillaDigitalForm) setFormIsValid(planillaDigitalForm.isValid());
    forceUpdate();
  };

  const populateForm = async () => {
    if (pp) {
      setPlanillaDigitalForm(PlanillaDigitalForm.build(pp, [], [], false, ''));
      setPlanillaPartido(pp);
      if (pp.getPartido().estaReprogramado()) {
        setShowIndicaDuracionPeriodos(true);
        setUseIndicaDuracionPeriodos(true);
      }
    } else if (id) {
      const savedPlanillaPartido = await system.getPlanillaPartidoSystem().getPlanillaPartidoIdentifiedBy(id);
      if (savedPlanillaPartido) {
        let events: EventoXPlanilla[] = [];
        let timeouts: TimeoutXPlanilla[] = [];

        if (!savedPlanillaPartido.getDiferido() && savedPlanillaPartido.enJuego()) {
          setShowPlanillaYaIniciadaError(true);
        }

        if (savedPlanillaPartido.getDiferido() && savedPlanillaPartido.enJuego()) {
          [events, timeouts] = await Promise.all([
            system.getEventoXPlanillaSystem().getListByPlanilla(savedPlanillaPartido),
            system.getTimeoutXPlanillaSystem().getListByPlanilla(savedPlanillaPartido),
          ]);
        }

        if (savedPlanillaPartido.finalizada()) {
          [events, timeouts] = await Promise.all([
            system.getEventoXPlanillaSystem().getListByPlanilla(savedPlanillaPartido),
            system.getTimeoutXPlanillaSystem().getListByPlanilla(savedPlanillaPartido),
          ]);
        }

        setPlanillaDigitalForm(PlanillaDigitalForm.build(savedPlanillaPartido, events, timeouts, false, ''));
        setPlanillaPartido(savedPlanillaPartido);

        if (savedPlanillaPartido && savedPlanillaPartido.iniciada() && savedPlanillaPartido.getDiferido()) {
          await iniciarPartido();
        }

        if (savedPlanillaPartido.getPartido().estaReprogramado()) {
          setShowIndicaDuracionPeriodos(true);
          setUseIndicaDuracionPeriodos(true);
        }
      }
    }

    if (planillaPartido && planillaPartido.iniciada() && planillaPartido.getDiferido()) {
      await iniciarPartido();
    }
  };
  const { isOnline } = useNavigatorOnline();
  const puedeAgregarJugadores = async () => {
    if (planillaDigitalForm) {
      changeBlockUI(true);
      try {
        if (isPartidoOnline) {
          const pp = planillaDigitalForm.getPlanillaPartidoInput().getValue() as PlanillaPartido;
          const fedId = pp.getPartido().getTorneo()?.getFederacion()?.getId();
          const fga = await system
            .getFederacionGestionAccionSystem()
            .getDatosGestionAccionByFedId(String(fedId!));
          setConfiguracionPuedeAgregarJugador(fga.getPlanillaDigitalPartidoIniciadoAgregarJugador());
        }
      } catch (error) {
        courier.messageError(error);
      }
      changeBlockUI(false);
    }
  };

  React.useEffect(() => {
    (async () => {
      await populateForm();
      await puedeAgregarJugadores();
    })();
  }, []);

  React.useEffect(() => {
    if (planillaPartido) {
      cantidadValida(planillaPartido.getPartido().getEqidLocal()!, 'L');
      cantidadValida(planillaPartido.getPartido().getEqidVisitante()!, 'V');
    }
  }, [planillaPartido?.getPlanillaPartidoJugadorList().length]);

  const cantidadValida = (eqId: number, eq: string) => {
    let ppt = 0;
    planillaPartido!.getPlanillaPartidoJugadorList().forEach((ppj) => {
      if (ppj.getEqid() === eqId) {
        ppt = ppt + 1;
      }
    });
    eq === 'L'
      ? setEquipoLocalCompleto(ppt >= MAX_HANDBALL_PLAYERS_PER_TEAM)
      : setEquipoVisitanteCompleto(ppt >= MAX_HANDBALL_PLAYERS_PER_TEAM);
  };

  const itemsMenu = React.useMemo((): ICommandBarItemProps[] => {
    if (onRefereeReview) return [];
    let ret: ICommandBarItemProps[] = [];
    ret.push(
      {
        key: 'vm',
        text: t('Cambiar vista'),
        iconProps: {
          iconName: 'ViewOriginal',
        },
        onClick: () => setViewMode(viewMode === 'G' ? 'L' : 'G'),
      },
      {
        key: 'swapSides',
        text: t('Cambiar lados'),
        iconProps: {
          iconName: 'SwitcherStartEnd',
        },
        onClick: () => swapTeamSides(),
      },
      {
        key: 'countdownMode',
        text: countdownMode ? t('Reloj cuenta progresiva') : t('Reloj cuenta regresiva'),
        iconProps: {
          iconName: 'Timer',
        },
        onClick: () => setCountdownMode(!countdownMode),
      },
      {
        key: 'jugadorMngr',
        text: t('Jugadores'),
        iconProps: {
          iconName: 'PlayerSettings',
        },
        subMenuProps: {
          items: [
            {
              key: 'changeDorsal',
              text: t('Cambiar N° dorsal'),
              iconProps: {
                iconName: 'Sync',
              },
              subMenuProps: {
                items: [
                  {
                    key: 'changeDorsalLocal',
                    text: 'Local',
                    iconProps: { iconName: 'Sync' },
                    onClick: () => {
                      setShowCambioCamiseta(true);
                      setShowCambioCamisetaTeam('L');
                    },
                  },
                  {
                    key: 'changeDorsalVisitante',
                    text: 'Visitante',
                    iconProps: { iconName: 'Sync' },
                    onClick: () => {
                      setShowCambioCamiseta(true);
                      setShowCambioCamisetaTeam('V');
                    },
                  },
                ],
              },
            },
            {
              key: 'addPlayer',
              text: t('Agregar jugador'),
              iconProps: {
                iconName: 'AddFriend',
              },
              subMenuProps: {
                items: [
                  {
                    key: 'addPlayerLocal',
                    text: 'Local',
                    iconProps: { iconName: 'AddFriend' },
                    onClick: () => {
                      setShowAgregarJugador(true);
                      setShowAgregarJugadorTeam('L');
                    },
                    disabled: equipoLocalCompleto || configuracionPuedeAgregarJugador || !isOnline,
                    title: equipoLocalCompleto
                      ? 'El equipo esta completo'
                      : !isOnline
                      ? 'No tenes conexion'
                      : 'Agregar jugador',
                  },
                  {
                    key: 'addPlayerVisitante',
                    text: 'Visitante',
                    iconProps: { iconName: 'AddFriend' },
                    onClick: () => {
                      setShowAgregarJugador(true);
                      setShowAgregarJugadorTeam('V');
                    },
                    disabled: equipoVisitanteCompleto || configuracionPuedeAgregarJugador || !isOnline,
                    title: equipoVisitanteCompleto
                      ? 'El equipo esta completo'
                      : !isOnline
                      ? 'No tenes conexion'
                      : 'Agregar jugador',
                  },
                ],
              },
            },
          ],
        },
      }
    );
    return ret;
  }, [
    formIsValid,
    navigate,
    planillaDigitalForm,
    setViewMode,
    viewMode,
    invertedTeams,
    setInvertedTeams,
    countdownMode,
    setCountdownMode,
    setShowCambioCamiseta,
    showCambioCamiseta,
    setShowCambioCamisetaTeam,
    showCambioCamisetaTeam,
    setShowAgregarJugador,
    showAgregarJugador,
    setShowAgregarJugadorTeam,
    showAgregarJugadorTeam,
    onRefereeReview,
    isOnline,
  ]);

  const updateColor = React.useCallback((ev: any, colorObj: IColor) => setLocalColor(colorObj.str), []);
  const updateVisColor = React.useCallback(
    (ev: any, colorObj: IColor) => setVisitanteColor(colorObj.str),
    []
  );

  const swapTeamSides = () => {
    setInvertedTeams(!invertedTeams);
  };

  const updateVersionInForm = (newVersion: string) => {
    const planillaPartido = planillaDigitalForm?.getPlanillaPartidoInput().getValue() as PlanillaPartido;
    planillaPartido.set__v(newVersion);
    planillaDigitalForm?.getPlanillaPartidoInput().setValue(planillaPartido);
    setPlanillaDigitalForm(planillaDigitalForm);
  };

  const iniciarPartido = async () => {
    changeBlockUI(true);
    try {
      if (id) {
        const newVersion = await system.getPlanillaPartidoSystem().iniciarPartido(id);
        updateVersionInForm(newVersion);
      }
    } catch (error) {
      courier.messageError(error);
      navigate(
        onRefereeReview ? routes.planillas_pendientes.route : routes.planilla_partido_programado.route
      );
    }
    changeBlockUI(false);
  };

  const finalizarPartido = async () => {
    if (planillaDigitalForm) {
      changeBlockUI(true);
      try {
        setShouldRetrySaveEvents(!shouldRetrySaveEvents);
        setShowConfirmacionPlanillaDialog(false);
        const newVersion = await system
          .getPlanillaPartidoSystem()
          .finalizarPartido(planillaDigitalForm.toPlanillaPartido());
        updateVersionInForm(newVersion);
      } catch (error) {
        if (!(error instanceof XhrRequestError && error.internetConnectionError())) {
          courier.messageError(error);
        }
      }
      changeBlockUI(false);
    }
  };

  const confirmarPlanilla = async (arbitroSelected: number, passwordArbitro: string) => {
    if (planillaDigitalForm) {
      changeBlockUI(true);
      try {
        setShouldRetrySaveEvents(!shouldRetrySaveEvents);
        await system.getPlanillaPartidoSystem().confirmarPlanilla(planillaDigitalForm.toPlanillaPartido(), {
          arbId: arbitroSelected,
          password: passwordArbitro,
        });
        courier.messageSuccess(
          'La planilla ha sido confirmada y el partido ha sido finalizado correctamente'
        );
        // navigate(routes.planilla_partido_programado.route);
        setShowConfirmacionPlanillaDialog(false);
        if (isOnline) {
          setShouldShowPDF(true);
        }
      } catch (error) {
        courier.messageError(error);
        setShowErrorConfirmacionArbitro(true);
      }
      changeBlockUI(false);
    }
  };

  const suspenderPartido = async (arbitroSelected: number, passwordArbitro: string) => {
    if (planillaDigitalForm) {
      changeBlockUI(true);
      try {
        setShouldRetrySaveEvents(!shouldRetrySaveEvents);
        await system.getPlanillaPartidoSystem().suspender(planillaDigitalForm.toPlanillaPartido(), {
          arbId: arbitroSelected,
          password: passwordArbitro,
        });
        courier.messageSuccess('El partido ha sido suspendido correctamente');
        // navigate(routes.planilla_partido_programado.route);
        setShowConfirmacionPlanillaDialog(false);
        if (isOnline) {
          setShouldShowPDF(true);
        }
      } catch (error) {
        courier.messageError(error);
        setShowErrorConfirmacionArbitro(true);
      }
      changeBlockUI(false);
    }
  };

  const descargarArchivoJSON = (suspendido: boolean) => {
    if (planillaDigitalForm) {
      PlanillaPartidoArchivoSincronizacion.download(
        props.environment,
        planillaDigitalForm,
        suspendido,
        tiempoSuspendido
      );
      setArchivoSyncDescargado(true);
    }
  };

  const onAcceptFinalizarPartido = (arbitroSelected: number | null, passwordArbitro: string) => {
    if (tipoFinalizacion === SUSPENDIDO) {
      if (!isOnline) {
        setShowConfirmacionPlanillaDialog(false);
        setShouldShowDescargarArchivoJSON(!shouldShowDescargarArchivoJSON);
      } else {
        suspenderPartido(arbitroSelected ? arbitroSelected : 0, passwordArbitro);
      }
    }
    if (tipoFinalizacion === FINALIZADO && arbitroSelected) {
      confirmarPlanilla(arbitroSelected, passwordArbitro);
    }
  };

  return (
    <ViewWrapperWithCommandBar
      withBorderBottom
      title={''}
      items={itemsMenu}
      overflowButtonStyles={defaultCommandBarButtonStyles}
      variant="highlight"
      titleBody="PlanillaDigital"
      // farItems={farItems}
    >
      <>
        {/* <button
          onClick={() => {
            test();
          }}
        >
          Boton de prueba
        </button> */}
        {planillaDigitalForm && (
          <PlanillaDigitalView
            system={system}
            form={planillaDigitalForm}
            courier={courier}
            changeBlockUI={changeBlockUI}
            onBlurCustomInput={onBlurCustomInput}
            viewMode={viewMode}
            localColor={localColor}
            visitanteColor={visitanteColor}
            isPartidoOnline={isPartidoOnline}
            invertedTeams={invertedTeams}
            countdownMode={countdownMode}
            matchIsOver={matchIsOver}
            useIndicaDuracionPeriodos={useIndicaDuracionPeriodos}
            shouldShowDescargarArchivoJSON={shouldShowDescargarArchivoJSON}
            setMatchIsOver={(v: boolean) => {
              setMatchIsOver(v);
              if (v) {
                finalizarPartido();
              }
            }}
            onRefereeReview={onRefereeReview}
            setOnRefereeReview={(v: boolean) => setOnRefereeReview(v)}
            iniciarPartido={iniciarPartido}
            descargarArchivoJSON={descargarArchivoJSON}
            setShowConfirmarPlanillaDialog={(v: boolean, tipo: string, minuto: string) => {
              setShowConfirmacionPlanillaDialog(v);
              setTipoFinalizacion(tipo);
              if (tipo === SUSPENDIDO) {
                setTiempoSuspendido(minuto);
              }
            }}
            archivoSyncDescargado={archivoSyncDescargado}
            startInExtra={startInExtra}
            tiempoPendienteJuegoEnSegundos={tiempoPendienteJuegoEnSegundos}
            shouldRetrySaveEvents={shouldRetrySaveEvents}
            shouldShowPDF={shouldShowPDF}
          />
        )}
        {planillaDigitalForm && (
          <>
            <SeleccionarColorDialog
              showInitialDialog={showInitialDialog}
              setShowInitialDialog={(v: boolean) => setShowInitialDialog(v)}
              localColor={localColor}
              updateColor={updateColor}
              visitanteColor={visitanteColor}
              updateVisColor={updateVisColor}
            ></SeleccionarColorDialog>

            <PlanillaYaIniciadaErrorDialog
              showPlanillaYaIniciadaError={showPlanillaYaIniciadaError}
              setShowPlanillaYaIniciadaError={setShowPlanillaYaIniciadaError}
            ></PlanillaYaIniciadaErrorDialog>

            <FinalizarPartidoDialog
              showConfirmacionPlanillaDialog={showConfirmacionPlanillaDialog}
              setShowConfirmacionPlanillaDialog={(v: boolean) => setShowConfirmacionPlanillaDialog(v)}
              setTipoFinalizacion={(v: string) => setTipoFinalizacion(v)}
              tipoFinalizacion={tipoFinalizacion}
              planillaDigitalForm={planillaDigitalForm}
              onBlurCustomInput={onBlurCustomInput}
              showErrorConfirmacionArbitro={showErrorConfirmacionArbitro}
              onRefereeReview={onRefereeReview}
              user={props.user}
              onAcceptFinalizarPartido={onAcceptFinalizarPartido}
            />

            <CambioCamisetaDialog
              form={planillaDigitalForm}
              system={system}
              courier={courier}
              changeBlockUI={changeBlockUI}
              isPartidoOnline={isPartidoOnline}
              showCambioCamiseta={showCambioCamiseta}
              showCambioCamisetaTeam={showCambioCamisetaTeam}
              setShowCambioCamiseta={(v: boolean) => setShowCambioCamiseta(v)}
              setShowCambioCamisetaTeam={(v: string) => setShowCambioCamisetaTeam(v)}
            ></CambioCamisetaDialog>

            {planillaPartido && (
              <AgregarJugadorDialog
                form={planillaDigitalForm}
                system={system}
                courier={courier}
                changeBlockUI={changeBlockUI}
                planillaPartido={planillaPartido}
                isPartidoOnline={isPartidoOnline}
                showAgregarJugador={showAgregarJugador}
                setShowAgregarJugador={(v: boolean) => setShowAgregarJugador(v)}
                setShowAgregarJugadorTeam={(v: string) => setShowAgregarJugadorTeam(v)}
                showAgregarJugadorTeam={showAgregarJugadorTeam}
              />
            )}

            <DuracionTiemposReglamentariosDialog
              form={planillaDigitalForm}
              system={system}
              courier={courier}
              changeBlockUI={changeBlockUI}
              isPartidoOnline={isPartidoOnline}
              showDialog={showIndicaDuracionPeriodos}
              setShowDialog={(v: boolean) => setShowIndicaDuracionPeriodos(v)}
              startInExtra={startInExtra}
              setStartInExtra={(v: boolean) => setStartInExtra(v)}
              setTiempoPendienteJuegoEnSegundos={(v: number) => setTiempoPendienteJuegoEnSegundos(v)}
            ></DuracionTiemposReglamentariosDialog>
          </>
        )}
      </>
    </ViewWrapperWithCommandBar>
  );
};

export default PlanillaPartidoViewController;
